import { render, staticRenderFns } from "./textPage.vue?vue&type=template&id=93b0f730&scoped=true&"
import script from "./textPage.vue?vue&type=script&lang=js&"
export * from "./textPage.vue?vue&type=script&lang=js&"
import style0 from "./textPage.vue?vue&type=style&index=0&id=93b0f730&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b0f730",
  null
  
)

export default component.exports